import { render, staticRenderFns } from "./Sidebar-vue.vue?vue&type=template&id=3d0eb2b8&"
import script from "./Sidebar-vue.vue?vue&type=script&lang=js&"
export * from "./Sidebar-vue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports